var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-popover",
    {
      attrs: {
        visible: _vm.open,
        overlayClassName: "no-padding common-filter-item-popup",
        placement: "bottom",
        trigger: "click",
      },
      on: {
        visibleChange: function (isVisible) {
          return (_vm.open = _vm.readonly ? false : isVisible)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticStyle: { width: "auto" },
          attrs: { slot: "content" },
          slot: "content",
        },
        [
          _c("div", { staticClass: "common-filter-item-form" }, [
            _c(
              "div",
              { staticClass: "common-filter-item-form-title" },
              [
                _c(
                  "span",
                  {
                    staticClass: "material-icons closeIcon",
                    on: { click: _vm.close },
                  },
                  [_vm._v(" close ")]
                ),
                _vm._v(" "),
                _vm.materialIcon
                  ? _c("span", { staticClass: "material-icons filterIcon" }, [
                      _vm._v(" " + _vm._s(_vm.materialIcon) + " "),
                    ])
                  : !!_vm.icon
                  ? _c(_vm.icon, { tag: "component" })
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { staticClass: "filterName ml-2" }, [
                  _vm._v(_vm._s(_vm.label)),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _vm.controlType === "select"
              ? _c(
                  "div",
                  { staticClass: "w-100" },
                  [
                    _c(
                      "a-select",
                      {
                        staticClass: "select-story",
                        attrs: {
                          value: _vm.clone.filterValue,
                          placeholder: _vm.$t("chatbotv2.select"),
                          "filter-option": false,
                        },
                        on: { select: _vm.handleSelect },
                      },
                      _vm._l(_vm.getSelectOptions(), function (option, i) {
                        return _c(
                          "a-select-option",
                          {
                            key: option.id || "option" + i,
                            attrs: { value: option.id },
                            on: {
                              click: function () {
                                return _vm.selectOptionClick(option.id)
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "blockTypeText" }, [
                              _vm._v(_vm._s(option.label)),
                            ]),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.controlType === "input"
              ? _c(
                  "div",
                  {
                    staticClass: "d-flex gap-5",
                    staticStyle: { width: "400px" },
                  },
                  [
                    _c(
                      "a-select",
                      {
                        staticClass: "w-100",
                        staticStyle: { width: "200px" },
                        model: {
                          value: _vm.clone.operator,
                          callback: function ($$v) {
                            _vm.$set(_vm.clone, "operator", $$v)
                          },
                          expression: "clone.operator",
                        },
                      },
                      _vm._l(_vm.availableOperators, function (operator) {
                        return _c(
                          "a-select-option",
                          { key: operator, attrs: { value: operator } },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(operator) +
                                "\n                    "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _vm.clone.operator !== "empty" &&
                    _vm.clone.operator !== "non_empty"
                      ? _c(
                          "div",
                          { staticClass: "col-md-8" },
                          [
                            _c("a-input", {
                              attrs: { value: _vm.clone.filterValue },
                              on: { change: _vm.handleInputChange },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.controlType === "text-input"
              ? _c(
                  "div",
                  {
                    staticClass: "w-100",
                    staticStyle: { "min-width": "250px" },
                  },
                  [
                    _c("a-input", {
                      attrs: {
                        value: _vm.clone.filterValue,
                        placeholder: _vm.label,
                        allowClear: "",
                      },
                      on: { change: _vm.handleInputChange },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.controlType === "custom-picker"
              ? _c(
                  "div",
                  { staticClass: "custom-picker-filter-wrapper" },
                  [
                    _c(
                      "CustomPickerInline",
                      _vm._b(
                        {
                          attrs: { items: _vm.getSelectOptions() },
                          model: {
                            value: _vm.clone.filterValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.clone, "filterValue", $$v)
                            },
                            expression: "clone.filterValue",
                          },
                        },
                        "CustomPickerInline",
                        _vm.getControlProps(),
                        false
                      )
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.controlType === "agent-picker"
              ? _c(
                  "div",
                  { staticClass: "agent-picker-filter-wrapper" },
                  [
                    _c(
                      "AgentPicker",
                      _vm._b(
                        {
                          model: {
                            value: _vm.clone.filterValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.clone, "filterValue", $$v)
                            },
                            expression: "clone.filterValue",
                          },
                        },
                        "AgentPicker",
                        _vm.getControlProps(),
                        false
                      )
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.controlType === "department-picker"
              ? _c(
                  "div",
                  { staticClass: "department-picker-filter-wrapper" },
                  [
                    _c(
                      "DepartmentPickerInline",
                      _vm._b(
                        {
                          model: {
                            value: _vm.clone.filterValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.clone, "filterValue", $$v)
                            },
                            expression: "clone.filterValue",
                          },
                        },
                        "DepartmentPickerInline",
                        _vm.getControlProps(),
                        false
                      )
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.controlType === "tags-picker"
              ? _c(
                  "div",
                  { staticClass: "department-picker-filter-wrapper" },
                  [
                    _c(
                      "TagPickerInline",
                      _vm._b(
                        {
                          model: {
                            value: _vm.clone.filterValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.clone, "filterValue", $$v)
                            },
                            expression: "clone.filterValue",
                          },
                        },
                        "TagPickerInline",
                        _vm.getControlProps(),
                        false
                      )
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.controlType === "channel-picker"
              ? _c(
                  "div",
                  { staticClass: "channel-picker-filter-wrapper" },
                  [
                    _c(
                      "ChannelPickerInline",
                      _vm._b(
                        {
                          model: {
                            value: _vm.clone.filterValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.clone, "filterValue", $$v)
                            },
                            expression: "clone.filterValue",
                          },
                        },
                        "ChannelPickerInline",
                        _vm.getControlProps(),
                        false
                      )
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.controlType === "date-range-picker"
              ? _c(
                  "div",
                  { staticClass: "date-ranger-picker-filter-wrapper" },
                  [
                    _c(
                      "DateRangerPickerInline",
                      _vm._b(
                        {
                          model: {
                            value: _vm.clone.filterValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.clone, "filterValue", $$v)
                            },
                            expression: "clone.filterValue",
                          },
                        },
                        "DateRangerPickerInline",
                        _vm.getControlProps(),
                        false
                      )
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "w-100",
                staticStyle: { "margin-top": "20px", width: "100%" },
              },
              [
                _c(
                  "SupsisButton",
                  {
                    attrs: {
                      primary: "",
                      small: "",
                      block: "",
                      disabled: !_vm.isChanged(),
                    },
                    on: { click: _vm.saveValue },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("chatbotv2.applyFilter")) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "filter-wrapper-preview",
          class: { readonly: _vm.readonly },
          attrs: { "data-filter-name": _vm.name },
        },
        [
          _vm.materialIcon
            ? _c("span", { staticClass: "material-icons mainIcon" }, [
                _vm._v(" " + _vm._s(_vm.materialIcon) + " "),
              ])
            : !!_vm.icon
            ? _c(_vm.icon, {
                tag: "component",
                staticClass: "material-icons mainIcon",
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "material-icons closeIcon",
              on: { click: _vm.remove },
            },
            [_vm._v(" close ")]
          ),
          _vm._v(" "),
          _c("span", { attrs: { "text-truncate": "", "text-actions": "" } }, [
            _c("span", { attrs: { "text-weight": "semi-bold" } }),
            _vm._v(" "),
            _c("span", { staticClass: "filter-value-text" }, [
              _vm._v(_vm._s(_vm.getLabel())),
            ]),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }